export default __webpack_public_path__ + "static/media/5.44d15f6c.png";